import type { PatientStrings } from '../index';

export const en: PatientStrings = {
  titleOne: 'Your new crown',
  titleMany: 'Your new crowns',
  tooth: 'Tooth',
  teeth: 'Teeth',
  both: 'Both',
  overview: 'Overview',
  front: 'Front',
  leftSide: 'Left side',
  rightSide: 'Right side',
  bitingSurface: 'Biting surface',
  show: 'Show',
  newCrown: 'New crown',
  newCrowns: 'New crowns',
  yourTeeth: 'Your teeth and gums',
  upperTeeth: 'Upper teeth',
  lowerTeeth: 'Lower teeth',
  hint: 'Drag to turn · pinch or scroll to zoom',
  zoomIn: 'Zoom in',
  zoomOut: 'Zoom out',
  turnSlowly: 'Turn slowly',
  stopTurning: 'Stop turning',
  backToStart: 'Back to the start',
  fullScreen: 'Full screen',
  exitFullScreen: 'Exit full screen',
  fromDentist: 'From your dentist',
  shadeNote: (shade) =>
    `The colour shown is close to shade ${shade}. The real crown is colour-matched in the lab.`,
  before: 'Before',
  after: 'After',
  seeInRoom: 'See it in your room',
  arNotSupported: 'Open this page on your phone to see the crown in your room.',
  appointmentTitle: 'Your fitting appointment',
  confirm: 'Confirm',
  confirmed: 'Confirmed — see you then',
  anotherTime: 'Ask for another time',
  anotherTimeSent: 'We have told your dentist you need another time.',
  language: 'Language',
  largerText: 'Larger text',
};
